import { Injectable,EventEmitter } from '@angular/core';
import { environment } from '../../environments/environment';
import { AuthService, AuthContextService } from '../_services/auth.service';
import * as io from "socket.io-client";

@Injectable()
export class SocketService {

  onlineUsers: EventEmitter<Object> = new EventEmitter();
  socketObject: EventEmitter<Object> = new EventEmitter();
  versionLogs: EventEmitter<Object> = new EventEmitter();
  ExpandedLogs: EventEmitter<Object> = new EventEmitter();
  mappedStatus: EventEmitter<boolean> = new EventEmitter();
  
  socketID

  constructor(private _authService:AuthService,
    private auth: AuthContextService) {
     
   }


  create_kb(io, data){
    io.emit('create_kb', data );

  }


  addNode(io,data){
    io.emit("add_node",data)

  }
  moveNode(io,data){
    io.emit("move_node",data)

  } 

  disconnectUser(io,data){
    io.emit("disconnect",data)

  }

  broadcastMessage(io,data){
    io.emit("broadcast_message",data)

  }


  deactivateUser(io,data){
    io.emit("deactivate_user",data)

  }

  itemClickLogs(io){
    io.emit("get_click_info")

  }

  itemClick(io,data){
    io.emit("item_clicked",data)

  }

  applyVersion(io,data){
    io.emit("apply_revert_point",data)
  }

  getHistory(io,data){
    io.emit("get_all_history",data)
  }

  save_node_details( io, data){
    // Saving node details of flow
    io.emit('save_node_details', data);
  }

  connectSocket(agentId,menu_name,currentUser){
    
    let release_id = this.auth.getReleaseId()._id;
    let query = "agent_id="+agentId + "&menu_id="+menu_name+"&token="+this._authService.getToken() 
    if(release_id){
      query = query + "&release_id=" + release_id
    }
    this.socketID =  io(environment.socket_service_api + menu_name,{query: query,transports: ['websocket'], upgrade: false, forceNew: true})
    return this.socketID;
         
  }

  connectFlowSocket(agentId,flowId,menu_name,currentUser){
    this.socketID =  io(environment.socket_service_api + menu_name,{query: "agent_id="+agentId + "&flow_id="+flowId +
      "&menu_id="+menu_name+"&token="+this._authService.getToken(),transports: ['websocket'], upgrade: false, forceNew: true})
    return this.socketID;
         
  }

}
